import './Accordion.scss';
import { component } from 'picoapp';

class AccordionItem extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    let header = this.querySelector('.header');
    header?.addEventListener('click', () => this.setAttribute('open', Number(this.getAttribute('open')) ? 0 : 1));
    header?.addEventListener('keydown', (ev) => {
      if (ev.keyCode == 13) {
        ev.preventDefault();
        this.setAttribute('open', Number(this.getAttribute('open')) ? 0 : 1);
      }
    });
  }
}

export default component((node, ctx) => {
  class Accordion extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('accordion-component', Accordion);
  if (!customElements.get('accordion-item')) {
    customElements.define('accordion-item', AccordionItem);
  }
});
